
import { useState, useEffect } from 'react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <h1>
              <a href="/" className="flex items-center gap-2">
                <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${isScrolled ? 'bg-[#0A2647]' : 'bg-white'}`}>
                  <i className={`ri-shield-cross-line text-xl ${isScrolled ? 'text-white' : 'text-[#0A2647]'}`}></i>
                </div>
                <span className={`text-xl font-bold transition-colors ${isScrolled ? 'text-[#0A2647]' : 'text-white'}`}>
                  InsuranceServicesTX
                </span>
              </a>
            </h1>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('about')}
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#0A2647]' : 'text-white/90 hover:text-white'
              }`}
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#0A2647]' : 'text-white/90 hover:text-white'
              }`}
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#0A2647]' : 'text-white/90 hover:text-white'
              }`}
            >
              Contact
            </button>
            <a
              href="tel:512-306-6245"
              className="flex items-center gap-2 bg-[#2196F3] hover:bg-[#1976D2] text-white px-5 py-2.5 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-fill"></i>
              512-306-6245
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              isScrolled ? 'text-[#0A2647]' : 'text-white'
            }`}
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white rounded-lg shadow-lg mt-2 p-4 absolute left-4 right-4">
            <nav className="flex flex-col gap-4">
              <button
                onClick={() => scrollToSection('about')}
                className="text-gray-700 hover:text-[#0A2647] font-medium text-left cursor-pointer"
              >
                About
              </button>
              <button
                onClick={() => scrollToSection('services')}
                className="text-gray-700 hover:text-[#0A2647] font-medium text-left cursor-pointer"
              >
                Services
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-gray-700 hover:text-[#0A2647] font-medium text-left cursor-pointer"
              >
                Contact
              </button>
              <a
                href="tel:512-306-6245"
                className="flex items-center justify-center gap-2 bg-[#2196F3] hover:bg-[#1976D2] text-white px-5 py-3 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill"></i>
                512-306-6245
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
